import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CertificateRequestDto} from './../../shared/model/certificate-trade-details.model';

import {SERVER_API_URL} from 'src/app/app.constants';
import {ILoadingTypeMySuffix} from 'src/app/shared/model/loading-type-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';
import {AdditionalPremiumRatePostData} from '../loss-payee-my-suffix/additionalPremiumRatePostData';

type EntityResponseType = HttpResponse<ILoadingTypeMySuffix>;
type EntityArrayResponseType = HttpResponse<ILoadingTypeMySuffix[]>;
type DraftEntityResponseType= HttpResponse<CertificateRequestDto[]>

@Injectable({ providedIn: 'root' })
export class ManualRequestsService {
    private resourceUrl = SERVER_API_URL + 'api/loading-types';
    private markUrlAsSafe=SERVER_API_URL+'api/finscan/mark-rule-as-safe';

    private _additionalPremiumRate: string = SERVER_API_URL + 'api/certificate-rule';
    
    private _additionalPremiumRateBulk: string=SERVER_API_URL+'api/bulk-certificate-rule';

    constructor(private http: HttpClient) {}

    create(loadingType: ILoadingTypeMySuffix): Observable<EntityResponseType> {
        return this.http.post<ILoadingTypeMySuffix>(this.resourceUrl, loadingType, { observe: 'response' });
    }

    update(loadingType: ILoadingTypeMySuffix): Observable<EntityResponseType> {
        return this.http.put<ILoadingTypeMySuffix>(this.resourceUrl, loadingType, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ILoadingTypeMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests';
        return this.http.get<ILoadingTypeMySuffix[]>(URL, { params: options, observe: 'response' });
    }
    queryWithStatus(req?: any, status?:  any): Observable<EntityArrayResponseType> {
        
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests-with-status';
        return this.http.put<ILoadingTypeMySuffix[]>(URL, status ,{ params: options, observe: 'response' });
    }

    queryWithStatusPolitical(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-political-requests-filter';
        return this.http.post<ILoadingTypeMySuffix[]>(URL, req ,{  observe: 'response' });
    }


    searchQuery(searchKey?: string, req?: any,status ?:any ): Observable<HttpResponse<ILoadingTypeMySuffix[]>> {
        // const options = createRequestOption(req);

        const URL = SERVER_API_URL + 'api/certificate-requests/search';

        if(searchKey){
            searchKey = searchKey.trim().replace('+', '');
            searchKey = encodeURI(searchKey);
        }else{
            searchKey = '';
        }
        return this.http.put<ILoadingTypeMySuffix[]>( URL + '?searchKey=' + searchKey, status,{ params: req, observe: 'response' });
    }

    searchQueryPolictical(searchKey?: string, req?: any,status ?:any ): Observable<HttpResponse<ILoadingTypeMySuffix[]>> {
        const URL = SERVER_API_URL + 'api/certificate-political-requests/search';
        if(searchKey){
            searchKey = searchKey.trim().replace('+', '');
            searchKey = encodeURI(searchKey);
        }else{
            searchKey = '';
        }
        return this.http.put<ILoadingTypeMySuffix[]>( URL + '?searchKey=' + searchKey, status,{ params: req, observe: 'response' });
    }

    queryForSpotClient(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests/spot-client-requests';
        return this.http.get<ILoadingTypeMySuffix[]>(URL, { params: options, observe: 'response' });
    }

    queryDraftCertificate(req?: any): Observable<DraftEntityResponseType> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests-drafts-list';
        return this.http.get<CertificateRequestDto[]>(URL, { params: options, observe: 'response' });
    }

    tableInfo(req?: any , status?:  any ): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests/info';
        return this.http.put<ILoadingTypeMySuffix[]>(URL, status, { params: options, observe: 'response' });
    }

    openRequestsQuery(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/open-certificate-requests';
        return this.http.get<ILoadingTypeMySuffix[]>(URL, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    // get the request details
    getById(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(SERVER_API_URL + url, { params: options, observe: 'response' }).map((res: any) => res);
    }

    // get the all requests
    getRequests(req?: any): Observable<any> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests';
        return this.http.get(URL, { observe: 'response' }).map((res: any) => res);
    }

    // get the all Rules based on request ID
    getRules(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get(SERVER_API_URL + url, { params: options, observe: 'response' }).map((res: any) => res);
    }

    markRuleAsSafe(req:any) {
        return this.http.post<any>(this.markUrlAsSafe, req, { observe: 'response' });
    }

    post(data: any, url: any): Observable<any> {
        return this.http.post<any>(SERVER_API_URL +url, data, { observe: 'response' });
    }

    get(url: string): Observable<HttpResponse<any>> {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }

    postAdditionalPremiumRate(data: AdditionalPremiumRatePostData, certificateRequestId: number): Observable<any> {
        const url: string = `${this._additionalPremiumRate}/${certificateRequestId}`;
        return this.http.post<AdditionalPremiumRatePostData>(url, data, { observe: "response" });
    }

    putAdditionalPremiumRate(data: AdditionalPremiumRatePostData,certificateRequestId: number): Observable<any> {
        const url: string = `${this._additionalPremiumRate}/${certificateRequestId}`;
        return this.http.put<AdditionalPremiumRatePostData>(url, data, { observe: "response" });
    }


    setSurveyAgentToRequest(url, data): Observable<any>{
        return this.http.post(SERVER_API_URL+url, data, { observe: 'response'});
    }

    getAllSurveyCompanies(url) {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }

    approveRequest(obj: any): Observable<any> {
        return this.http.post(SERVER_API_URL + 'api/certificate-requests/political-risk/approve', obj, { observe: 'response' });
    }

    rejectRequest(obj: any): Observable<any> {
        return this.http.post(SERVER_API_URL + 'api/certificate-requests/political-risk/reject', obj, { observe: 'response' });
    }

    queryWithFilter(req?: any): Observable<EntityArrayResponseType> {
        
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/certificate-requests-filter';
        return this.http.post<ILoadingTypeMySuffix[]>(URL,req ,{  observe: 'response' });
    }

}
